"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileLike = void 0;
const tslib_1 = require("tslib");
const fs_1 = tslib_1.__importDefault(require("fs"));
const path_1 = tslib_1.__importDefault(require("path"));
const getFileLike = async (like) => {
    let res = undefined;
    const fileName = path_1.default.basename(like);
    const extName = path_1.default.extname(like);
    const pathName = path_1.default.dirname(like);
    console.log('', { pathname: pathName, fileName, extName });
    // const dirStatRes = await new Promise( (resolve) => fs.stat( pathName, ( err, stats ) => resolve({ err, stats })));
    // console.log('stats', dirStatRes)
    const dirContentsRes = await new Promise((resolve) => fs_1.default.readdir(pathName, (err, files) => resolve({ err, data: files })));
    //console.log('files', dirContentsRes)
    if (dirContentsRes.data) {
        const matchedFileName = dirContentsRes.data.find((item) => {
            const baseName = path_1.default.basename(item);
            const extName = path_1.default.extname(item);
            const fileNameToMatch = baseName.replace(extName, '');
            return fileNameToMatch === fileName;
        });
        res = matchedFileName ? path_1.default.join(pathName, matchedFileName) : undefined;
    }
    else {
        console.log(dirContentsRes.data && dirContentsRes.data instanceof Array);
    }
    //console.log('File Name', res )
    return res;
};
exports.getFileLike = getFileLike;
